export type ScrollPosition = {
  x: number;
  y: number;
};

export function getScrollPosition(): ScrollPosition {
  return {
    x: window.scrollX || document.documentElement.scrollLeft || 0,
    y: window.scrollY || document.documentElement.scrollTop || 0,
  };
}

export function restoreScrollPosition(position: ScrollPosition) {
  window.scrollTo(position.x, position.y);
}

export function focusWithoutScroll(element: HTMLElement | null | undefined) {
  if (!element) return;

  const scroll = getScrollPosition();
  try {
    element.focus({ preventScroll: true });
  } catch {
    element.focus();
  }
  restoreScrollPosition(scroll);
  requestAnimationFrame(() => restoreScrollPosition(scroll));
}

export function preserveScrollWhile(action: () => void) {
  const scroll = getScrollPosition();
  action();
  restoreScrollPosition(scroll);
  requestAnimationFrame(() => {
    restoreScrollPosition(scroll);
    requestAnimationFrame(() => restoreScrollPosition(scroll));
  });
}
